module.exports = {
	danish: require("./da").stopwords,
	dutch: require("./nl").stopwords,
	english: require("./en").stopwords,
	french: require("./fr").stopwords,
	galician: require("./gl").stopwords,
	german: require("./de").stopwords,
	italian: require("./it").stopwords,
	polish: require("./pl").stopwords,
	portuguese: require("./pt").stopwords,
	romanian: require("./ro").stopwords,
	russian: require("./ru").stopwords,
	spanish: require("./es").stopwords,
	swedish: require("./se").stopwords,
	persian: require("./fa").stopwords,
	arabic: require("./ar").stopwords,
	czech: require("./cs").stopwords,
	turkish: require("./tr").stopwords,
	vietnam: require("./vn").stopwords
};
